module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src560599644/src/~/babel-runtime/core-js/object/define-property.js
// module id = 0hsw
// module chunks = 6